<template lang="html">
  <section class="cart-page">
    <!-- CART ITEMS -->
    <div class="cart-container">
      <header class="cart-header">
        <h1>YOUR CART (5 ITEMS)</h1>
      </header>

      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Product Info</th>
              <th>Price (Ksh)</th>
              <th>Quantity</th>
              <th>Total (Ksh)</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="product-img product-img--placeholder" aria-hidden="true">
                  <i class="fa-solid fa-box"></i>
                </div>
              </td>
              <td>
                <p class="prod-name">Soccer</p>
                <p class="prod-info">High-quality sound with noise cancellation and 20-hour battery life.</p>
              </td>
              <td>2,000</td>
              <td>4</td>
              <td>8,000</td>
              <td><i class="fa-solid fa-trash-can"></i></td>
            </tr>

            <tr>
              <td>
                <div class="product-img product-img--placeholder" aria-hidden="true">
                  <i class="fa-solid fa-box"></i>
                </div>
              </td>
              <td>
                <p class="prod-name">Soccer Gloves</p>
                <p class="prod-info">Comfortable and durable gloves with extra grip.</p>
              </td>
              <td>1,500</td>
              <td>4</td>
              <td>6,000</td>
              <td><i class="fa-solid fa-trash-can"></i></td>
            </tr>

            <tr>
              <td>
                <div class="product-img product-img--placeholder" aria-hidden="true">
                  <i class="fa-solid fa-box"></i>
                </div>
              </td>
              <td>
                <p class="prod-name">Nike Mercurial</p>
                <p class="prod-info">Premium football shoes for agility and comfort.</p>
              </td>
              <td>4,500</td>
              <td>2</td>
              <td>9,000</td>
              <td><i class="fa-solid fa-trash-can"></i></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="checkout-actions">
        <button class="btn checkout">Checkout</button>
        <button class="btn continue">Continue Shopping</button>
      </div>
    </div>

    <!-- SUMMARY & COUPON SECTION -->
    <aside class="summary-section">
      <div class="coupon-box">
        <header><h2>Discount</h2></header>
        <p>If you have a discount voucher, apply here:</p>
        <div class="coupon-input">
          <input type="text" placeholder="Enter coupon code" />
          <button>Apply</button>
        </div>
      </div>

      <div class="summary-box">
        <header><h2>Cart Summary</h2></header>
        <div class="summary-details">
          <p>Total</p><p>Ksh 5,678</p>
        </div>
        <div class="summary-details">
          <p>Coupon Discount</p><p><span>20%</span>Ksh -1,344</p>
        </div>
        <div class="summary-details">
          <p>Delivery Charges</p><p>Ksh 50</p>
        </div>
        <div class="summary-details">
          <p>VAT</p><p>Ksh 200</p>
        </div>
        <div class="summary-details total">
          <p>Payable Amount</p><p>Ksh 3,556</p>
        </div>

        <div class="checkout-actions">
          <button class="btn cancel">Cancel Order</button>
          <button class="btn place">Place Order</button>
        </div>
      </div>
    </aside>
  </section>
</template>

<script>
export default {
  name: 'AdminCart'
}
</script>

<style scoped>
/* Layout */
.cart-page {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  background: var(--background-color1);
  padding: 1rem;
}

/* Cart container */
.cart-container {
  flex: 2 1 65%;
  background: var(--background-color2);
  border-radius: 8px;
  overflow: hidden;
}

.cart-header {
  background: green;
  color: #fff;
  padding: 0.5rem;
}

.cart-header h1 {
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0;
}

/* Table styles */
.table-container {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.7rem;
}

th,
td {
  padding: 0.5rem;
  text-align: left;
  color: var(--text-color1);
}

thead {
  background: rgba(255, 255, 255, 0.1);
}

tbody tr {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.product-img {
  width: 45px;
  height: 45px;
  border-radius: 5px;
}

.product-img--placeholder {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--background-color1);
  border: 1px dashed rgba(255, 255, 255, 0.15);
  color: var(--text-color2);
  font-size: 1rem;
}

.prod-name {
  font-weight: 600;
  font-size: 0.7rem;
  color: var(--text-color2);
}

.prod-info {
  font-size: 0.6rem;
  opacity: 0.8;
}

/* Actions */
.checkout-actions {
  display: flex;
  justify-content: space-between;
  padding: 0.6rem;
  background: var(--background-color2);
}

.btn {
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 0.7rem;
  cursor: pointer;
  color: #fff;
  transition: 0.3s;
}

.checkout {
  background: green;
}

.continue {
  background: rgb(0, 110, 255);
}

.cancel {
  background: crimson;
}

.place {
  background: green;
}

/* Summary section */
.summary-section {
  flex: 1 1 30%;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.coupon-box,
.summary-box {
  background: var(--background-color2);
  border-radius: 8px;
  padding: 0.8rem;
}

.coupon-box header,
.summary-box header {
  background: green;
  color: #fff;
  border-radius: 4px;
  padding: 0.3rem 0.5rem;
  font-size: 0.4rem;
}

.coupon-box p {
  font-size: 0.65rem;
  margin: 0.4rem 0;
}

.coupon-input {
  display: flex;
  gap: 0.4rem;
}

.coupon-input input {
  flex: 1;
  padding: 4px 6px;
  font-size: 0.7rem;
  border: 1px solid var(--text-color2);
  background: transparent;
  color: var(--text-color1);
  border-radius: 4px;
}

.coupon-input button {
  font-size: 0.7rem;
  background: green;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
}

/* Cart summary */
.summary-details {
  display: flex;
  justify-content: space-between;
  margin: 0.3rem 0;
  font-size: 0.7rem;
}

.summary-details span {
  color: maroon;
  font-size: 0.6rem;
  margin-right: 3px;
}

.summary-details.total p {
  font-weight: 700;
}

/* Icons */
i {
  color: crimson;
  font-size: 0.9rem;
  cursor: pointer;
}

/* Responsive */
@media (max-width: 1060px) {
  .cart-page {
    flex-direction: column;
  }
  .cart-container,
  .summary-section {
    flex: 1 1 100%;
  }
}

@media (max-width: 600px) {
  .table th:nth-child(3),
  .table td:nth-child(3),
  .table th:nth-child(4),
  .table td:nth-child(4),
  .table th:nth-child(5),
  .table td:nth-child(5) {
    display: none;
  }
  .cart-header h1 {
    font-size: 0.8rem;
  }
  .btn {
    font-size: 0.65rem;
  }
}
</style>
